import React, { useMemo } from 'react';
import { ieltsWeb } from '@/utils/env';

import i18n from '@/locales/init';

export interface IScoreLink {
  className?: string;
  recordId: number;
  type: 4 | 5; // 1大作文 2小作文
}

export const ScoreLink = React.memo<IScoreLink>(({ recordId, type, className }) => {
  const url = useMemo(() => {
    return `${ieltsWeb}simulate/#/writing-evaluation/${recordId}/${type}`;
  }, [recordId, type]);
  return <a className={className} href={url} target="_blank" rel="noreferrer">{i18n.t('点击查看评分报告')}</a>;
});
